import { keepPreviousData, useQuery } from '@tanstack/react-query';

import useApi from '@/hooks/useApi/useApi';
import { queryKeys } from '@/lib/queryKeys';
import { Project } from '@/types/types';

export interface ProjectFilters {
  status?: Project['status'][];
  expired_end_date?: boolean;
  search?: string;
  manager_ids?: (string | number)[];
  category_ids?: (string | number)[];
}

const useProjects = (filters?: ProjectFilters) => {
  const { axiosInstance } = useApi();

  return useQuery({
    queryKey: queryKeys.projects.list(filters).queryKey,
    queryFn: async () => {
      const params: Record<string, unknown> = {};

      if (filters?.status?.length) params.status = filters.status;
      if (filters?.expired_end_date !== undefined)
        params.expired_end_date = filters.expired_end_date;
      if (filters?.search) params.search = filters.search;
      if (filters?.manager_ids?.length) params.manager_id = filters.manager_ids;
      if (filters?.category_ids?.length) params.category_id = filters.category_ids;

      const { data } = await axiosInstance.get<Project[]>('/api/v1/projects', {
        params,
      });
      return data;
    },
    placeholderData: keepPreviousData,
  });
};

export default useProjects;
